import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { useAppSelector } from "../../redux";
import { NAME_MAP } from "./consts";
import { Commet } from "react-loading-indicators";

const margin = { top: 30, right: 100, bottom: 30, left: 100 }; // Increased left margin for building name

// Define an array of custom color values
const customColors = [
  "#FFA00F",
  "#AED773",
  "#00693E",

  "#AAD6E4",
  "#0055A3",

  "#003C73",
];

const Rankings = ({ width, height }) => {
  const graphData = useAppSelector((state) => state.electric).data;

  const n = 12;
  const segmentPadding = 2;
  const ref = useRef();

  useEffect(() => {
    if (graphData.length === 0) return;

    function drawChart() {
      try {
        d3.select(ref.current).selectAll("*").remove();

        const data = graphData.filter(
          (d) => d.timeStamp === graphData[0].timeStamp
        );

        const svg = d3
          .select(ref.current)
          .attr("viewBox", [0, 0, width, height]);

        const x = d3
          .scaleLinear()
          .domain([0, d3.max(data, (d) => d.curValue)])
          .range([margin.left, width - margin.right]);

        const y = d3
          .scaleBand()
          .domain(d3.range(n))
          .rangeRound([margin.top, margin.top + height])
          .padding(0.1);

        // Use scaleOrdinal to map domain values to custom colors
        const color = d3
          .scaleOrdinal()
          .domain([0, d3.max(data, (d) => d.curValue) + 1])
          .range(customColors);

        svg
          .selectAll("g.bar-group")
          .data(data.sort((a, b) => d3.descending(a.curValue, b.curValue)))
          .enter()
          .append("g")
          .attr("class", "bar-group")
          .attr("transform", (d, i) => `translate(0, ${y(i)})`)
          .each(function (d) {
            const barWidth = x(d.curValue);
            const segmentWidth = barWidth / Math.ceil(d.curValue / 60);
            const segmentCount = 1; //Math.ceil(d.curValue / 50); // Number of segments
            const remainingWidth = barWidth - segmentWidth * segmentCount;

            for (let i = 0; i < segmentCount; i++) {
              d3.select(this)
                .append("rect")
                .attr("fill", color(d.curValue))
                .attr("x", i * segmentWidth)
                .attr("y", 0)
                .attr("width", segmentWidth - segmentPadding)
                .attr("height", y.bandwidth())
                .append("title")
                .text(`${d.name}: ${Math.round(d.curValue)}`);
            }

            // Adjust the width of the last segment to accommodate for any remaining width
            d3.select(this)
              .select("rect:nth-child(" + segmentCount + ")")
              .attr("width", segmentWidth - segmentPadding + remainingWidth);
          });

        // Append text for building name
        svg
          .selectAll(".building-name")
          .data(data)
          .enter()
          .append("text")
          .attr("class", "building-name")
          .attr("x", (d) => x(d.curValue) + 9)
          .attr("y", (d, i) => y(i) + 1 + y.bandwidth() / 4)
          .attr("dy", "0.35em")
          .attr("font-size", "12px")
          .attr("font-weight", 600)
          .attr("font-family", "National2")
          .text((d) => NAME_MAP[d.name] || d.name);

        // Append text for curValue
        svg
          .selectAll(".curValue")
          .data(data)
          .enter()
          .append("text")
          .attr("class", "curValue")
          .attr("x", (d) => x(d.curValue) + 9)
          .attr("y", (d, i) => y(i) - 1 + (y.bandwidth() * 3) / 4)
          .attr("dy", "0.35em")
          .attr("font-size", "12px")
          .attr("font-weight", 400)
          .attr("font-family", "National2")
          .text((d) => Math.round(d.curValue) + " kWh");

        // Append text for last updated timestamp
        // svg
        //   .append("text")
        //   .attr("class", "last-updated")
        //   // .attr("x", width - margin.right + 75)
        //   // .attr("y", height - margin.bottom + 55)
        //   .attr("x", width - 50)
        //   .attr("y", height + 50)

        //   .attr("text-anchor", "end")
        //   .attr("font-size", "14px")
        //   .style("font-style", "italic")
        //   .attr("font-family", "National2")
        //   .text("Last Updated: " + formatTime(lastUpdated));

        console.log("Chart drawn successfully.");
      } catch (error) {
        console.error("Error while drawing chart:", error);
      }
    }

    drawChart();
  }, [graphData, height, width]);

  return graphData.length === 0 ? (
    <Commet color="#32cd32" size="medium" text="" textColor="" />
  ) : (
    <svg
      ref={ref}
      viewBox={`0 0 ${width} ${height}`}
      style={{
        width: "90%",
        height: "100%",
        maxWidth: "100%",
        overflow: "visible",
        font: "10px National2",
      }}
    />
  );
};

export default Rankings;
